import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { HelperService } from 'src/app/services/Helper/helper.service';
import notify from 'devextreme/ui/notify';
import { ProviderParameters, BankDetailParameters } from 'src/app/models/ui/ProviderParameters';

@Component({
  selector: 'app-provider-management',
  templateUrl: './provider-management.component.html',
  styleUrls: ['./provider-management.component.css']
})
export class ProviderManagementComponent implements OnInit {
  isAuthorized: string;

  providers: any[];
  rejectedProviders: any[];
  contractTypes: any[];
  roles: any[];
  status: any[];
  countries: any[];

  currentProvider: ProviderParameters = new ProviderParameters();
  
  currentBank: BankDetailParameters = new BankDetailParameters();

  loadingVisible = false;
  popupVisible = false;
  rPopupVisible = false;

  constructor(private helper: HelperService, private lookupService: LookupService, private registrationService: RegistrationService) { }

  ngOnInit() {
    this.isAuthorized = localStorage.getItem("isAuthorized");

    if(this.isAuthorized === "true") {
      this.helper.setTitle('Provider - Provider Management');

      this.lookupService.getPendingProviders().subscribe(data => this.providers = data);
      this.lookupService.getRejectedProviders().subscribe(data => this.rejectedProviders = data);
      this.lookupService.getContractTypes().subscribe(data => this.contractTypes = data);
      this.lookupService.getRoles().subscribe(data => this.roles = data);
      this.lookupService.getStatus().subscribe(data => this.status = data);
      this.lookupService.getCountries().subscribe(data => this.countries = data);

      this.openPage('Pending');
    }
    else
      location.assign("#/login-form");
  }

  openPage(pageName) {
  var i, tabcontent;

  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  document.getElementById(pageName).style.display = "block";

  if(pageName==="Pending") {
    document.getElementById("pendingBtn").style.backgroundColor = "crimson";
    document.getElementById("pendingBtn").style.color = "white";
    document.getElementById("rejectedBtn").style.backgroundColor = "white";
    document.getElementById("rejectedBtn").style.color = "black";
  } else if(pageName ==="Rejected") {
    document.getElementById("rejectedBtn").style.backgroundColor = "crimson";
    document.getElementById("rejectedBtn").style.color = "white";
    document.getElementById("pendingBtn").style.backgroundColor = "white";
    document.getElementById("pendingBtn").style.color = "black";
  }
  }

  approveProvider(e) {
    this.loadingVisible = true;
    if(e.key.SupplierNumber === null || e.key.SupplierNumber === "") {
      notify("Please fill in a Supplier Number");
      this.loadingVisible = false;
    }
    else 
      this.registrationService.approveProvider(e.key).subscribe(data => this.displayResult(data));
  }

  rejectProvider(e) {
    console.log(e.data);
    this.currentProvider = e.data;
    this.rPopupVisible = true;
  }

  processRejection(data)
  {
    this.currentProvider.RejectionReason = data;
    console.log(data);
    this.registrationService.rejectProvider(this.currentProvider).subscribe(data => this.displayResult(data));
  }

  getBankDetails(Id) {
    console.log(Id);
    this.lookupService.getBankDetails(Id).subscribe(data => this.processBankData(data));
  }

  processBankData(bank) {
    this.currentBank = bank;
    this.popupVisible = true;
  }

  downloadBankLetter(Id) {
    this.loadingVisible = true;
    this.lookupService.getBankDetails(Id).subscribe(x => {
      var newBlob = new Blob([this.base64ToArrayBuffer(x.BankLetter)]);

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
      }

      const data = window.URL.createObjectURL(newBlob);

      var link = document.createElement('a');
      link.href = data;

      const reader = new FileReader();
      reader.readAsText(newBlob);
      setTimeout(() => {
        if(reader.result.toString().includes("PDF")) 
          link.download = "Bank Letter.pdf";
        else
          link.download = "Bank Letter.doc";
        
          window.addEventListener('focus', e=>URL.revokeObjectURL(link.href), {once:true});
          
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          
          setTimeout(function () {
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

          this.loadingVisible = false;
        }, 2000);
      });
    }

    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
         var ascii = binaryString.charCodeAt(i);
         bytes[i] = ascii;
      }
      return bytes;
   }

  displayResult(data) {
    this.loadingVisible = false;
    alert(data);
    setTimeout(() => {
      location.reload();
    }, 2000);
  }
}